import json from './sprite.js';

export default {
    handle: 'ENG_SPT9-Book_225002585',
    label: 'en_SPT9-Book_225002585',
    json,
};
